<script setup>
import {RouterLink} from 'vue-router'
</script>
<template>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="navbar-brand" style="display: flex;">
      <img src="@/assets/nithra_logo_1.svg" width="200" height="50" class="d-inline-block align-top" alt="">
      <p class="d-none d-sm-block">MESSAGING PORTAL</p>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        <!--        <li class="nav-item active">-->
        <!--          <RouterLink :to="'/home' + root" class="nav-link">Home</RouterLink>-->
        <!--        </li>-->
        <li class="nav-item">
          <RouterLink
              :to="'/bulk/message' + root"
              class="nav-link">Bulk Message
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink
              :to="'/msg91/bulk/message' + root"
              class="nav-link">MSG 91
          </RouterLink>
        </li>
<!--        <li class="nav-item">-->
<!--          <RouterLink-->
<!--              :to="'/meta/template' + root"-->
<!--              class="nav-link">Templates-->
<!--          </RouterLink>-->
<!--        </li>-->
        <li class="nav-item">
          <RouterLink
              :to="'/message/logs' + root"
              class="nav-link">Logs
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink
              :to="'/message/userWise' + root"
              class="nav-link disabled">User-wise
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink
              :to="'/block/list' + root"
              class="nav-link disabled">Block-list
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink
              :to="'/contact/group' + root"
              class="nav-link disabled">Contact-group
          </RouterLink>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            {{ rootUser }}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" href="#">Later</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="logOutMethod" href="#">Log out</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  <div class="nav-scroller bg-white shadow-sm d-none d-sm-block" v-if="integrity == true">
    <nav class="nav nav-underline">
      <!--      <RouterLink :to="'/home' + root" class="nav-link">Home</RouterLink>-->
      <RouterLink
          v-if="['shanbraja', 'admin', 'parthipan'].includes(rootUser)"
          :to="'/number/integration' + root"
          class="nav-link">Integration
      </RouterLink>
      <RouterLink
          :to="'/message/analytics' + root"
          class="nav-link disabled">Analytics
      </RouterLink>
      <RouterLink
          :to="'/wa/orders' + root"
          class="nav-link disabled">Orders
      </RouterLink>
      <RouterLink
          :to="'/message/userPricing' + root"
          class="nav-link disabled">Pricing
      </RouterLink>
      <RouterLink
          v-if="['shanbraja', 'admin', 'mowcika', 'amaravathi', 'muthukumar', 'prasanthjobs', 'BoopathirajaR', 'KanimozhiV', 'MegalaP', 'PoovarasiM', 'DeepaA', 'VigneshS', 'Muthukumar.K', 'ElakkiyaP', 'mani.handball', 'dhivyas', 'DharaniA', 'suganyaj', 'DivyaP', 'sangeetha.s', 'saranya.g'].includes(rootUser)"
          :to="'/wa/mat/leads' + root"
          class="nav-link disabled">MAT LEADS
      </RouterLink>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      root: "",
      rootUser: "",
      integrity: true
    }
  },
  async created() {
    const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'));
    if (localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token")) {
      this.root = "/" + NMPUSER.token
      this.rootUser = NMPUSER.userTGname
      // if (this.rootUser == 'shanbraja' || this.rootUser == 'admin' || this.rootUser == 'parthipan' || this.rootUser == 'mowcika')
      //   this.integrity = true;
      // else
      //   this.integrity = false;
    } else {
      localStorage.removeItem('NMPUSER')
      this.$router.push('/');
    }
  },
  methods: {
    logOutMethod() {
      localStorage.removeItem('NMPUSER')
      this.$router.push('/');
    }
  }
}
</script>
